import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DesktopCountryForm from "../DesktopCountryForm";
import { reactIcons } from "../../../utils/icons";
import DatePicker from "react-datepicker";

const EntityForm = ({
  handleChange,
  formError,
  handleCountryChange,
  selectedCountry,
  Country,
  dialCode,
  onStepComplete
}) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <Formik
      initialValues={{
        type: "Mine",
        primaryContactName: "",
        name: "",
        RegistrationNumber: "",
        email: "",
        mobile: "",
        website: "",
        address_line_1: "",
        dateOfIncorporation: null,
        countryOfIncorporation: ""
      }}
      validationSchema={Yup.object({
        type: Yup.string().required("Business Type is required"),
        primaryContactName: Yup.string().required(
          "Primary Contact Name is required"
        ),
        name: Yup.string().required("Entity Name is required"),
        RegistrationNumber: Yup.string()
          .required("Registration Number is required")
          .trim()
          .min(3, "Must be at least 3 characters"),
        email: Yup.string()
          .email("Invalid email format")
          .required("Email Address is required"),
        mobile: Yup.string()
          .matches(/^[0-9]+$/, "Only numbers are allowed")
          .required("Mobile Number is required"),
        website: Yup.string()
          .url("Invalid URL format")
          .test(
            "is-url-or-empty",
            "Invalid URL format",
            (value) =>
              !value ||
              /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(
                value
              )
          ),
        address_line_1: Yup.string()
          .max(100, "Maximum 100 characters allowed")
          .required("Physical Address is required"),
        dateOfIncorporation: Yup.date()
          .nullable()
          .typeError("Invalid date format")
          .required("Date of Incorporation is required")
      })}
      onSubmit={(values) => {
        console.log("Form Submitted", values);
        // Pass the validated values to parent component
        onStepComplete(values);
      }}
    >
      {({ isValid, dirty, submitForm, setFieldValue, values }) => (
        <>
          <Form className="lg:grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
            <div className="input_field mb-3 lg:mb-0">
              <div className="relative">
                <label className="mb-2 block text-white">Business Type</label>
                <Field
                  as="select"
                  className="bg-white text-12 lg:text-14"
                  name="type"
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue("type", e.target.value);
                  }}
                >
                  <option value="Mine" className="bg-white text-black">
                    Mine
                  </option>
                </Field>
                <span className="absolute top-[43px] lg:top-[50px] right-[10px]">
                  {reactIcons.arrowDown}
                </span>
              </div>
              <ErrorMessage name="type" component="div" className="form-eror" />
            </div>
            <div className="mb-3 lg:mb-0">
              <label className="mb-2 block text-white">Primary Contact Name</label>
              <Field
                type="text"
                name="primaryContactName"
                className="text-input text-black text-12 lg:text-14 border"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("primaryContactName", e.target.value);
                }}
              />
              <ErrorMessage
                name="primaryContactName"
                component="div"
                className="form-eror"
              />
            </div>
            <div className="mb-3 lg:mb-0">
              <label className="mb-2 block text-white">Entity Name</label>
              <Field
                type="text"
                name="name"
                className="text-input text-black text-12 lg:text-14 border"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("name", e.target.value);
                }}
              />
              <ErrorMessage name="name" component="div" className="form-eror" />
            </div>
            <div className="mb-3 lg:mb-0">
              <label className="mb-2 block text-white">Registration Number</label>
              <Field
                type="text"
                name="RegistrationNumber"
                className="text-input text-black border-[#BEBEBE] text-12 lg:text-14 border"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("RegistrationNumber", e.target.value);
                }}
              />
              <ErrorMessage
                name="RegistrationNumber"
                component="div"
                className="form-eror"
              />
            </div>
            <DesktopCountryForm
              errorMsg={formError}
              handleCountryChange={handleCountryChange}
              selectedCountry={selectedCountry}
              Country={Country}
              name="countryOfIncorporation"
            />
            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-white relative">
                Date of Incorporation
              </label>
              <DatePicker
                className="!w-full block text-white bg-primary-500 text-black py-2 px-4 rounded-md border border-yellow-500 focus:ring-2 focus:ring-yellow-500 focus:outline-none placeholder-gray-400"
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  setFieldValue("dateOfIncorporation", date);
                }}
                wrapperClassName="w-full"
              />
              <ErrorMessage
                name="dateOfIncorporation"
                component="div"
                className="form-eror"
              />
            </div>
            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-white">Website</label>
              <Field
                type="text"
                name="website"
                className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("website", e.target.value);
                }}
              />
              <ErrorMessage
                name="website"
                component="div"
                className="form-eror"
              />
            </div>
            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-white">Email Address</label>
              <Field
                type="text"
                name="email"
                className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("email", e.target.value);
                }}
              />
              <ErrorMessage
                name="email"
                component="div"
                className="form-eror"
              />
            </div>
            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-white">Mobile Number</label>
              <div className="relative">
                <span className="cursor-pointer absolute left-[1px] top-[2px] py-[16.4px] lg:py-[11.4px] px-[6px] border border-r-black border-y-0 border-l-0 min-w-[50px] h-[45px] flex items-center justify-center">
                  +{dialCode}
                </span>
                <Field
                  type="text"
                  name="mobile"
                  className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14 pl-[60px]"
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue("mobile", e.target.value);
                  }}
                />
                <ErrorMessage
                  name="mobile"
                  component="div"
                  className="form-eror"
                />
              </div>
            </div>
            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-white">Physical Address</label>
              <Field
                as="textarea"
                name="address_line_1"
                className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                rows={6}
                maxLength={100}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("address_line_1", e.target.value);
                }}
              />
              <ErrorMessage
                name="address_line_1"
                component="div"
                className="form-eror"
              />
            </div>
          </Form>
          <div className="flex gap-2 mt-5 justify-end items-center">
            <button
              type="button"
              onClick={submitForm}
              disabled={!isValid}
              className={`btn btn-primary ${
                !isValid ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              Step 2 {reactIcons.arrowright}
            </button>
          </div>
        </>
      )}
    </Formik>
  );
};

export default EntityForm;
